<template>
    <div class="dropdown" ref="dropdown">
        <button :class="`btn btn-secondary dropdown-toggle ${buttonClass}`" type="button" :id="id" data-bs-toggle="dropdown" :aria-expanded="false" ref="dropdownButton" :aria-label="buttonAriaLabel">
            <slot name="button-content-before-icon"/>
            <Icon v-if="iconTypeOpen && iconTypeClosed" class="icon-open-close" :type="open ? iconTypeOpen : iconTypeClosed"/>
            <Icon v-else-if="iconTypeOpen" class="icon-open" :type="iconTypeOpen"/>
            <Icon v-else-if="iconTypeClosed" class="icon-close" :type="iconTypeClosed"/>
            <slot name="button-content-after-icon"/>
        </button>
        <div :class="(open ? 'dropdown-menu show' : 'dropdown-menu d-none')" :aria-labelledby="id">
            <slot name="dropdown-content"/>
        </div>
    </div>
</template>
<script>
import Icon from '../image/icon.vue';
import { Dropdown } from 'bootstrap';

var showFunction = undefined;
var hideFunction = undefined;
var listenerElement = undefined;
export default {
    name: "Dropdown",
    props: {
        id: String,
        buttonClass: {
            type: String,
            required: false,
            default: "d-flex",
        },
        iconTypeOpen: {
            type: String,
            required: false,
            default: "chevron-up",
        },
        iconTypeClosed: {
            type: String,
            required: false,
            default: "chevron-down",
        },
        buttonAriaLabel: {
            type: String,
            required: false,
            default: "",
        },
    }, 
    components: {
        Icon
    },
    data: function () {
        return {
            bsDropdown: null,
            open: false,
        };
    },
    mounted() {
        if(this.$refs.dropdown) {
            this.bsDropdown = new Dropdown(this.$refs.dropdownButton);

            listenerElement = this.bsDropdown._element;
            showFunction = ()=> this.open = true;
            hideFunction = ()=> this.open = false;
            
            listenerElement.addEventListener('show.bs.dropdown', showFunction);
            listenerElement.addEventListener('hide.bs.dropdown', hideFunction);
        }
    },
    beforeUnmount() {
        if(listenerElement && showFunction && hideFunction) {
            listenerElement.removeEventListener('show.bs.dropdown', showFunction);
            listenerElement.removeEventListener('hide.bs.dropdown', hideFunction);
        }
    },
};
</script>